<template>
  <div class="ql-snow">
    <div class="ql-editor">
      <div v-html="data"></div>
    </div>
  </div>
</template>
<script>
import "quill/dist/quill.core.css"; // import styles
import "quill/dist/quill.snow.css"; // for snow theme
import "quill/dist/quill.bubble.css"; // for bubble theme
export default {
  name: "quill-view",
  props: {
    data: {
      type: String,
    },
  },
};
</script>
<style scoped>
.ql-editor {
  padding: 0px;
}

/* Preserve whitespace in displayed content */
.ql-editor,
.ql-editor p,
.ql-editor div {
  white-space: pre-wrap;
}
</style>